// Module
var code = "<h1>TRANSFER CARD</h1>";
// Exports
module.exports = code;